import { StoreIncidents } from '../../Types/StoreTypes';
export const SET_INCIDENTS = 'SET_INCIDENTS';

export function setIncidents(incidents: StoreIncidents) {
    return { type: SET_INCIDENTS, payload: incidents };
}
